import React, { FunctionComponent, ReactNode } from 'react';
import { AxiosError } from 'axios';
import classNames from 'classnames';
import styles from './styles.module.scss';

type MyExpectedResponseType = {
  error: string;
};

export function isAxiosError<ResponseType>(
  error: Error,
): error is AxiosError<ResponseType> {
  return !!(error as AxiosError).isAxiosError;
}

function getErrorMessage(error: unknown) {
  if (error instanceof Error) {
    if (isAxiosError<MyExpectedResponseType>(error)) {
      let message;
      if (error.response?.data?.error) {
        message = error.response?.data?.error;
        return message;
      }
      message = error.response?.data;
      if (message && typeof message === 'string') return message;
      message = error.response?.statusText;
      if (message) return message;
    }
    return error.message;
  } else if (typeof error === 'string') {
    return error;
  } else if (typeof error === 'object' && error !== null) {
    if ('error' in error) return `${(error as { error: unknown }).error}`;
    if ('message' in error) return `${(error as { message: unknown }).message}`;
  }
  return 'An unknown error occurred';
}

interface Props {
  error?: unknown;
  messageMap?: { [index: string]: string | undefined };
  children?: ReactNode;
}

export const ErrorMessage: FunctionComponent<Props> = ({
  error,
  messageMap,
  children,
}) => {
  const hasErrorProp = !!error;
  if (!hasErrorProp && !children) {
    return null;
  }

  let errorPropMessage: string | null = null;
  if (hasErrorProp) {
    const errorMessage = getErrorMessage(error);
    errorPropMessage = messageMap?.[errorMessage] ?? errorMessage;
  }
  return (
    <div className={classNames('launchpad-error', styles.error)}>
      {errorPropMessage}
      {children}
    </div>
  );
};
